var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg001Parrot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m79.375 441.31c-48.902-46.624-79.375-112.408-79.375-185.31 0-141.385 114.615-256 256-256s256 114.615 256 256c0 72.901-30.473 138.686-79.375 185.31z",
    fill: "#ffce00"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "m324.838 103.861v337.449h107.787c41.419-39.49 69.617-92.724 77.277-152.385z",
    fill: "#ffa300"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m154.074 265.857c-48.182 24.309-81.231 74.237-81.231 131.889 0 15.165 2.287 29.796 6.534 43.567 21.638 20.629 46.886 37.503 74.697 49.587l13.278-112.522z",
    fill: "#2cc47f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.926 265.857-9.868 116.201 9.868 108.842c27.811-12.084 53.059-28.958 74.697-49.587 4.247-13.771 6.534-28.402 6.534-43.567-.001-57.653-33.049-107.58-81.231-131.889z",
    fill: "#079e59"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 77.104c-56.292 0-101.926 45.634-101.926 101.926v311.875c31.233 13.571 65.701 21.095 101.926 21.095s70.693-7.524 101.926-21.095v-311.876c0-56.291-45.634-101.925-101.926-101.925z",
    fill: "#1dd882"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m357.926 179.029c0-56.278-45.611-101.902-101.884-101.925v434.895c36.21-.006 70.663-7.529 101.884-21.094z",
    fill: "#2cc47f"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 310.299,
    cy: 169.641,
    fill: "#333940",
    rx: 17.267,
    ry: 17.267,
    transform: "matrix(.23 -.973 .973 .23 73.903 432.664)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.701,
    cy: 169.641,
    fill: "#555a66",
    rx: 17.267,
    ry: 17.267,
    transform: "matrix(.707 -.707 .707 .707 -60.878 192.311)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.704 208.5-26.662 44.617-26.746-44.617v-54.663c0-14.748 11.956-26.704 26.704-26.704 14.748 0 26.704 11.956 26.704 26.704z",
    fill: "#ffce00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.704 153.837c0-14.734-11.933-26.68-26.662-26.703v125.983l26.662-44.617z",
    fill: "#fdba12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg001Parrot);
export default __webpack_public_path__ + "static/media/001-parrot.ce0a7c89b096f2d477fefeaeaaeef08f.svg";
export { ForwardRef as ReactComponent };